module.exports = __webpack_public_path__ + "missive-logo-0633ebbdcd64f8cce16d3383f89a7def.svg";